import { Dayjs } from 'dayjs';

import { SDate } from '@summit/core';

import { EboObject } from './ebo-object';

export class EboEvent extends EboObject {
  eventDate: Dayjs;

  constructor(jsonData?: Partial<EboEvent>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.eventDate) {
        this.eventDate = SDate.newUtc(jsonData.eventDate);
      }
    }
  }
}
